import type { Dictionnaire } from '../type';

export const appels: Dictionnaire['appels'] = {
  erreurs: {
    camera: "Sirocco can't access your camera.",
    micro: "Sirocco can't access your microphone.",
    connexion: "The connection couldn't be established. Try again from another network.",
    compteOfficiel: "The app's account doesn't take calls. Write to it instead.",
    pasAmi: 'You can only call your friends. Add this member first.',
    pasAbouti: "The call couldn't go through.",
    nExistePlus: 'This call no longer exists.',
  },
  natif: {
    pasAbouti: "The call couldn't go through.",
  },
  ecran: {
    quelquun: 'Someone',
    personneNaRepondu: 'No one answered.',
    pasParti: "The call couldn't be placed.",
    pasAbouti: "The call couldn't go through.",
    echanger: 'Swap the two views',
    reduire: 'Minimize call',
    appel: 'Call',
    connexion: 'Connecting…',
    appelVideo: 'Video call…',
    appelEnCours: 'Calling…',
    refuser: 'Decline',
    repondreVideo: 'Answer with video',
    repondre: 'Answer',
    accepter: 'Accept',
    reactiverMicro: 'Unmute',
    couperMicro: 'Mute',
    montrerCamera: 'Show my camera',
    cameraPasOuverte: "The camera couldn't be turned on.",
    rallumerCamera: 'Turn my camera back on',
    couperCamera: 'Turn off my camera',
    ecouteur: 'Switch back to the earpiece',
    hautParleur: 'Switch to speaker',
    raccrocher: 'Hang up',
    entrant: { video: 'Incoming video call…', audio: 'Incoming call…' },
    son: (detail: string) => `Sound: ${detail}`,
    natifMuet: "the native layer isn't responding",
  },
};
